import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { ICampaign } from "@edp-models/edp-campaigns.model";
import { getUser } from "@edp-store/selectors/user.selectors";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { Contract } from "@edp-components/edp-contract";
import { EdpResponseBody } from "@edp-models/response.model";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { GetCampaigns } from "@edp-store/actions/dashboard.actions";
import { EdpUser } from "@edp-models/user.model";
import { DashboardService } from "@edp-services/dashboard.service";
import { TranslateService } from "@ngx-translate/core";
import { EnvService } from "@edp-services/env.service";

@Component({
    selector: "edp-e-consent-modal",
    templateUrl: "./edp-e-consent-modal.component.html",
    styleUrls: ["./edp-e-consent-modal.component.scss"],
})
export class EdpEConsentModalComponent implements OnInit {
    @Input() public data: IModalData;
    @Output() public closeSideBar = new EventEmitter<boolean>();

    public campaign: ICampaign;
    public selectedContract: any;
    public form: FormGroup;
    public selectedContractIndex = 0;
    public pgPerQuestion: number;
    public formObject: any;
    public showLoader = true;
    public userPartnerNumber: string;
    public userContract: Contract;
    public userNif: string;
    private user: EdpUser;
    private contract: Contract;
    public thanksImage: string = null;

    public invoiceAdvices = null;
    public partnershipDiscounts = null;
    public afterContract = null;
    public formSubmitted = false;
    public sucessFormSend = false;

    public constructor(
        private store: Store<IAppState>,
        private edpModalService: EdpModalService,
        private fb: FormBuilder,
        private dashboardService: DashboardService,
        private translate: TranslateService,
        private envService: EnvService,
        ) {}

    public ngOnInit(): void {
        this.campaign = this.data.collection;
        this.thanksImage = `${this.envService.appUrl()}/resource/image/` + this.translate.instant("pt.edp.edponline.consent.thanks.img");
        this.buildForm();
    }
    public buildForm() {
        this.form = this.fb.group({
            invoiceAdvicesGroup: new FormGroup({
                invoiceAdvices: new FormControl(this.invoiceAdvices, Validators.required),
            }),
            partnershipDiscountsGroup: new FormGroup({
                partnershipDiscounts: new FormControl(this.partnershipDiscounts, Validators.required),
            }),
            afterContractGroup: new FormGroup({
                afterContract: new FormControl(this.afterContract, Validators.required),
            })
        });
    }
    public submitForm() {
        this.formObject = this.form.value;
        this.formSubmitted = true;

        if (this.form.valid) {

            const formResponses = [
                { ID: "CONS_3", Value: this.formObject.invoiceAdvicesGroup.invoiceAdvices },
                { ID: "CONS_2", Value: this.formObject.partnershipDiscountsGroup.partnershipDiscounts },
                { ID: "CONS_4", Value: this.formObject.afterContractGroup.afterContract },
            ];

            this.store.select(getUser).subscribe(user => {
                this.user = user;
            });

            this.store.select(getContract).subscribe(contract => (this.contract = contract));

            this.store.dispatch(new ShowLoader(true));

            const args = {
                channel: "browser",
                campaignId: this.campaign.id,
                partnerNumber: this.user.partnerNumber.toString(),
                accountNumber: this.contract.AccountNumber.toString(),
                nif: this.user.nif.toString(),
                attributes: formResponses
            };

            this.dashboardService.consentSubscription(args).subscribe((resp: EdpResponseBody) => {
                if (resp.Success) {
                    this.sucessFormSend = true;
                    this.store.dispatch(new GetCampaigns(this.user.partnerNumber, this.contract.AccountNumber));
                }
                this.store.dispatch(new ShowLoader(false));
            },
            error => {
                this.store.dispatch(new ShowLoader(false));
            });
        }
    }

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }
}
